import { render, staticRenderFns } from "./family_list.vue?vue&type=template&id=718307b6&scoped=true"
import script from "./family_list.vue?vue&type=script&lang=js"
export * from "./family_list.vue?vue&type=script&lang=js"
import style0 from "./family_list.vue?vue&type=style&index=0&id=718307b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718307b6",
  null
  
)

export default component.exports